//ローディング
import {loading} from "../include/module";
loading();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//画像切り替え
import {visualChange} from "../include/module";
visualChange();


// WEBPACK FOOTER //
// script.js